module.exports = __webpack_public_path__ + "img/alert.1c47f014.png";